import { render } from "./DegreeMap.vue?vue&type=template&id=39355042&scoped=true"
import script from "./DegreeMap.vue?vue&type=script&lang=js"
export * from "./DegreeMap.vue?vue&type=script&lang=js"

import "./DegreeMap.vue?vue&type=style&index=0&id=39355042&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39355042"]])

export default __exports__